import { Component } from '@angular/core';

@Component({
  selector: 'ap-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.css']
})
export class PageComponent {

  constructor() {}

}
